// project imports
import getColors from 'utils/getColors';
import getShadow from 'utils/getShadow';
import { bhsTokens } from '../tokens';
import type { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - INPUT BORDER & SHADOWS ||============================== //

type InputColor = 'primary' | 'secondary' | 'error' | 'warning' | 'info' | 'success';

type ColorStyleProps = {
  variant: InputColor;
  theme: Theme;
};

function getColor({ variant, theme }: ColorStyleProps) {
  const colors = getColors(theme, variant);
  const { light } = colors;

  const shadows = getShadow(theme, `${variant}`);

  return {
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: light },
    '&.Mui-focused': { boxShadow: shadows, '& .MuiOutlinedInput-notchedOutline': { border: '1px solid', borderColor: light } }
  };
}

// ==============================|| OVERRIDES - OUTLINED INPUT ||============================== //

export default function OutlinedInput(theme: Theme) {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          boxSizing: 'border-box',
          height: bhsTokens.input.height,
          padding: `var(--mantis-input-padding, ${bhsTokens.input.padding})`
        },
        notchedOutline: {
          borderColor: theme.palette.grey[300]
        },
        root: {
          minHeight: bhsTokens.input.height,
          borderRadius: bhsTokens.shape.borderRadius,
          ...getColor({ variant: 'primary', theme }),
          '&.Mui-error': { ...getColor({ variant: 'error', theme }) }
        },
        sizeSmall: { '& .MuiOutlinedInput-input': { padding: `var(--mantis-input-padding-small, ${bhsTokens.input.padding})` } },
        multiline: { '& .MuiOutlinedInput-input': { padding: 0 } },
        colorSecondary: getColor({ variant: 'secondary', theme }),
        colorError: getColor({ variant: 'error', theme }),
        colorWarning: getColor({ variant: 'warning', theme }),
        colorInfo: getColor({ variant: 'info', theme }),
        colorSuccess: getColor({ variant: 'success', theme })
      }
    }
  };
}
